import React from 'react'

// material ui
import FormHelperText from '@mui/material/FormHelperText'

const QueryErrors = props => {
  const { errors } = props

  return (
    <>
      {errors.map(error => (
        <FormHelperText key={error.path}>{error.message}</FormHelperText>
      ))}
    </>
  )
}

export default QueryErrors
